import { Card, CardBody, Text, Flex, LinkExternal } from 'uikit'
import { useTranslation } from 'react-i18next'
import { NodeRound, BetPosition } from 'state/types'
// import useTheme from 'hooks/useTheme'
import ReclaimPositionButton from '../ReclaimPositionButton'
import useIsRefundable from '../../hooks/useIsRefundable'
import { RoundResultBox } from '../RoundResult'
import MultiplierArrow from './MultiplierArrow'
import CardHeader from './CardHeader'
import { Image } from 'components'
import styled from 'styled-components'

interface CanceledRoundCardProps {
  round: NodeRound
}

const CancelContainer = styled.div`
  width: 100%;
  height: 40px;
  border: 1px solid #c9c9c9;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 17px;
`

const CanceledRoundCard: React.FC<CanceledRoundCardProps> = ({ round }) => {
  const { t } = useTranslation()
  // const { theme } = useTheme()
  const { isRefundable, setIsRefundable } = useIsRefundable(round.epoch)
  const { epoch } = round

  const handleSuccess = async () => {
    setIsRefundable(false)
  }

  return (
    <Card>
      <CardHeader
        status="canceled"
        icon={<Image src={require('assets/images/prediction/cancel.svg').default} width="24px" />}
        title={t('PREDICTION_41')}
        epoch={round.epoch}
      />
      <CardBody p="16px">
        <MultiplierArrow isDisabled />
        <RoundResultBox>
          <Flex flexDirection="column" alignItems="center" pb="15px">
            <CancelContainer>
              <Text bold color={isRefundable ? 'text' : 'textDisabled'}>
                {t('PREDICTION_64')}
              </Text>
            </CancelContainer>
            {isRefundable && <ReclaimPositionButton epoch={epoch} onSuccess={handleSuccess} width="100%" my="8px" />}
            {/* todo */}
            <LinkExternal href="https://docs.mojitoswap.finance/products/prediction" external>
              <Text color="primary" fontSize="14px" bold>
                {t('PREDICTION_65')}
              </Text>
            </LinkExternal>
          </Flex>
        </RoundResultBox>
        <MultiplierArrow betPosition={BetPosition.BEAR} isDisabled />
      </CardBody>
    </Card>
  )
}

export default CanceledRoundCard
